import React, { ElementRef, useEffect } from 'react';
import { useFormikContext } from 'formik';

const ErrorFocus = ({ subForms }: { subForms?: boolean }) => {

    const { isSubmitting, isValidating, errors } = useFormikContext();

    let keys = []
    if (!subForms) {
        keys = Object.keys(errors);
    } else {
        keys = Object.keys(errors).reduce((prev, subForm) => {
            const fields = Object.keys(errors[subForm])
            const fieldsNames = fields.map(f => `${subForm}.${f}`)
            return prev.concat(fieldsNames)
        }, [])
    }
    useEffect(() => {
        if (keys.length > 0 && isSubmitting && !isValidating) {
            let selector = `[name="${keys[0]}"]`;
            let errorElement: ElementRef<'input' | 'button' | 'label'> = document.querySelector(selector);
            if (!errorElement) {
                selector = `[for="${keys[0]}"]`;
                errorElement = document.querySelector(selector);
                if (errorElement) {
                    const bodyRect = document.body.getBoundingClientRect()
                    const elemRect = errorElement.getBoundingClientRect();
                    window.scrollTo({behavior:'smooth', top:(elemRect.top - bodyRect.top - 100)})
                }
                return;
            }
            errorElement.focus();
        }
    })

    return null;

}

export default ErrorFocus